import React from "react";
import Slider from "react-slick";
import { useRouter } from "../../hooks/router";

import './SliderPoster.scss'

import PosterInfo from "../Header/PosterInfo";

import icon_eye from '../Header/images/view.png'
import icon_eye_active from '../Header/images/eye.png'
import icon_favourites from '../NavBar/images/heart.png'
import icon_favourites_active from '../pages_child/InfoMovie/images/favourite_active.png'
import icon_watch_now from '../Header/images/watch_now.png'
import { translateWord } from "../Util/util";

export default function SliderPoster({ continueWatchList }) {
    const router = useRouter()
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        fade: true,
        autoplaySpeed: 3000,
        cssEase: "linear"
    };

    return (
        <Slider {...settings}>
            {continueWatchList.map((elem, index) => {
                return (
                    <div className="poster" key={index} >
                        <div className="container">
                            <div className="info_poster" onClick={() => router.push(`/movie/${elem.id}`)}>
                                <PosterInfo elem={elem} noDesc={true} />
                                <div className="info_view">
                                    <div className="view_movie">
                                        <img src={elem.watched ? icon_eye_active : icon_eye} alt="" />
                                    </div>
                                    <div className="favorite_poster">
                                        <img src={elem.favorites ? icon_favourites_active : icon_favourites} alt="" />
                                    </div>
                                    <div className="watch_info_movie" onClick={() => router.push(`/movie/${elem.id}`)}>
                                        <img src={icon_watch_now} alt="" />
                                        <span>{translateWord('Watch Now')}</span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="poster_image">
                            <div className="gradient_poster">

                            </div>
                            <img src={elem.highlight_tv || elem.backdrop} alt="" />
                        </div>
                    </div>
                )

            })}
        </Slider>
    );
}
//"http://git.inorain.com:4000/movies/1636071763052_AnandMilindSajidWajid.jpg"
{/*    <div key={index} className="slider_elem" >*/
}
{/*        <img src={elem.backdrop} className={'img_slider'} alt=""/>*/
}
{/*            <h1 style={{height:'50vh'}}></h1>*/
}
{/*    </div>*/
}